import VueRouter from 'vue-router';
import auth from './auth';

export default function decorete(router: VueRouter) {
  auth(router);
}
